import { render, staticRenderFns } from "./compatibility.form.vue?vue&type=template&id=542c30b4&"
import script from "./compatibility.form.vue?vue&type=script&lang=ts&"
export * from "./compatibility.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports